<template>
  <div>
    <b-row>
      <b-col v-for="(item, index) in items"
        :key="index"
        class="p-3"
      >
        <b-card>
          <b-media>
            <template v-slot:aside>
              <b-img :src="item.image" fluid width="130" height="80" alt="placeholder"></b-img>
            </template>

            <h5 class="mt-3 fw-bold">{{ item.name}}</h5>
            <p>{{ item.description }} </p>
            <b-link :href="item.website" target="_blank">{{ item.website }}</b-link>
          </b-media>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-pagination
            v-model="page"
            :total-rows="sourceData.length"
            :per-page="countPerPage"
            pills
            hide-goto-end-buttons
            aria-controls="my-table"
            align="center"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { contentComputed } from '@state/helpers';

export default {
  name: "List",

  components: { },

  props: {
    count: {
      type: Array,
      default: null,
    },
    source: {
      type: String,
      default: null,
    }
  },

  data() {
    return {
      page: 1,
      windowWidth: 992, // md by default
    }
  },

  computed: {
    ...contentComputed,

    /**
     * Items source
     */
    sourceData() {
      return this.source.split('.').reduce((o,i)=>o[i], this.info);
    },

    /**
     * Get the items from the store source
     *
     * @return {string}
     */
    items() {
      const start = (this.page -1)* this.countPerPage
      return this.sourceData.slice(start, start + this.countPerPage);
    },

    /**
     * How many items per page
     * @return {number|*}
     */
    countPerPage(){
      if (this.count === null) {
        return 8;
      }

      switch (this.breakpoint){
        case "xs":
        case "sm":
          return this.count[0];
        case "md":
          return this.count[1];
        case "lg":
          return this.count[2];
      }
      // xl
      return this.count[3];
    },

    /**
     * Current breakpoint
     *
     * @return {string}
     */
    breakpoint(){
      if (this.windowWidth < 575) {
        return 'xs';
      }

      if(this.windowWidth < 767) {
        return 'sm';
      }

      if(this.windowWidth < 992) {
        return 'md';
      }

      if(this.windowWidth < 1200) {
        return 'lg';
      }

      return 'xl';
    }
  },

  mounted() {
    // listen the screen changes
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    });

    this.windowWidth = window.innerWidth;
  }

}
</script>

<style lang="scss">
  @import '@design';

  .client-container {
    height: 140px;
  }

  .flip-container {
    width: 215px;
    margin: 0 auto;
    cursor: pointer;
  }

  .back-content{
    width: 215px;
    height: 110px;
    padding: 25px 2px 2px 2px;
    font-weight: bold;
    color: white;
    text-align: center;
    text-transform: uppercase;
    background-color: $color-container-bg;
    border-radius: 10px;
    cursor: pointer;
  }

  .page-item.active .page-link {
    color: white !important;
    background-color: $color-container-bg !important;
    border-color: $color-container-bg !important;
  }

  .page-link {
    color: $color-container-bg !important;
  }
</style>
